import * as i0 from '@angular/core';
import { EventEmitter, Component, Injectable, Input, Output, NgModule } from '@angular/core';
import * as i1 from 'abs-ngx-library/src/lib/core';
import { ProductCouponService } from 'abs-ngx-library/src/lib/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';

function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_1_span_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵlistener("click", function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_1_span_6_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.setProductDetails("offer-detail")); })("keyup.enter", function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_1_span_6_Template_span_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.setProductDetails("offer-detail")); });
    i0.ɵɵtext(1, "Details");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵattribute("aria-label", "Details for " + ctx_r1.singleCouponText + " coupon for " + ctx_r1.getProductFullName());
} }
function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "button", 11);
    i0.ɵɵlistener("click", function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_1_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r1.clipCoupon()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "div", 12)(4, "div", 13);
    i0.ɵɵtext(5);
    i0.ɵɵtemplate(6, ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_1_span_6_Template, 2, 1, "span", 14);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "couponAddBtn", ctx_r1.coupons[0].offerId, "");
    i0.ɵɵattribute("data-toggle", ctx_r1.showBoxtop && ctx_r1.coupons[0].offerSubPgm === "07" ? ctx_r1.modalAttrName : null)("data-target", ctx_r1.showBoxtop && ctx_r1.coupons[0].offerSubPgm === "07" ? ctx_r1.modalIdName : null)("aria-label", "Clip coupon for " + ctx_r1.singleCouponText + " for " + ctx_r1.getProductFullName());
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.singleCouponText, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showDetailsLink);
} }
function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_2_ng_container_1_span_8_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵlistener("click", function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_2_ng_container_1_span_8_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(7); return i0.ɵɵresetView(ctx_r1.setProductDetails("offer-detail")); })("keyup.enter", function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_2_ng_container_1_span_8_Template_span_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(7); return i0.ɵɵresetView(ctx_r1.setProductDetails("offer-detail")); });
    i0.ɵɵtext(1, "Details");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(7);
    i0.ɵɵattribute("aria-label", "Details for " + ctx_r1.singleCouponText + " coupon for " + ctx_r1.getProductFullName());
} }
function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelement(2, "span", 18);
    i0.ɵɵelementStart(3, "div", 19);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 12)(6, "div", 13);
    i0.ɵɵtext(7);
    i0.ɵɵtemplate(8, ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_2_ng_container_1_span_8_Template, 2, 1, "span", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 20);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "span", 21);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.clippedText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.singleCouponText, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showDetailsLink);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Add ", ctx_r1.coupons[0].minPurchaseQty, " Total for Offer ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.adaText);
} }
function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_2_ng_container_2_span_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵlistener("click", function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_2_ng_container_2_span_7_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(7); return i0.ɵɵresetView(ctx_r1.setProductDetails("offer-detail")); })("keyup.enter", function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_2_ng_container_2_span_7_Template_span_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(7); return i0.ɵɵresetView(ctx_r1.setProductDetails("offer-detail")); });
    i0.ɵɵtext(1, "Details");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(7);
    i0.ɵɵattribute("aria-label", "Details for " + ctx_r1.singleCouponText + " coupon for " + ctx_r1.getProductFullName());
} }
function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 22)(2, "div", 23);
    i0.ɵɵelement(3, "span", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 12)(5, "div", 13);
    i0.ɵɵtext(6);
    i0.ɵɵtemplate(7, ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_2_ng_container_2_span_7_Template, 2, 1, "span", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 20)(9, "span", 25);
    i0.ɵɵtext(10, "\uD83C\uDF89");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "span", 26);
    i0.ɵɵtext(12, "Congratulations");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "span", 27);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "span", 21);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.singleCouponText, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showDetailsLink);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r1.offerCompletedText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.adaText);
} }
function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_2_ng_container_1_Template, 13, 5, "ng-container", 0)(2, ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_2_ng_container_2_Template, 17, 4, "ng-container", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isOfferCompleteVisible(ctx_r1.coupons[0]));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isOfferCompleteVisible(ctx_r1.coupons[0]));
} }
function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_1_Template, 7, 7, "div", 7)(2, ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_div_2_Template, 3, 2, "div", 8);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.coupons[0].status === "U" || ctx_r1.coupons[0].deleted === true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.coupons[0].status === "C" && ctx_r1.coupons[0].deleted === false);
} }
function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_2_ng_container_2_span_8_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵlistener("click", function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_2_ng_container_2_span_8_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.setProductDetails("offer-detail")); })("keyup.enter", function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_2_ng_container_2_span_8_Template_span_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.setProductDetails("offer-detail")); });
    i0.ɵɵtext(1, "Details");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵattribute("aria-label", "Details for " + ctx_r1.singleCouponText + " coupon for " + ctx_r1.getProductFullName());
} }
function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelement(2, "span", 18);
    i0.ɵɵelementStart(3, "div", 19);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 12)(6, "div", 13);
    i0.ɵɵtext(7);
    i0.ɵɵtemplate(8, ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_2_ng_container_2_span_8_Template, 2, 1, "span", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 20);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "span", 21);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.clippedText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.singleCouponText, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showDetailsLink && (ctx_r1.configObj == null ? null : ctx_r1.configObj.programType) !== "1P_SNS");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Add ", ctx_r1.coupons[0].minPurchaseQty, " Total for Offer ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.adaText);
} }
function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_2_ng_container_3_span_7_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵlistener("click", function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_2_ng_container_3_span_7_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.setProductDetails("offer-detail")); })("keyup.enter", function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_2_ng_container_3_span_7_Template_span_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.setProductDetails("offer-detail")); });
    i0.ɵɵtext(1, "Details");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵattribute("aria-label", "Details for " + ctx_r1.singleCouponText + " coupon for " + ctx_r1.getProductFullName());
} }
function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 22)(2, "div", 23);
    i0.ɵɵelement(3, "span", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 12)(5, "div", 13);
    i0.ɵɵtext(6);
    i0.ɵɵtemplate(7, ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_2_ng_container_3_span_7_Template, 2, 1, "span", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 20)(9, "span", 25);
    i0.ɵɵtext(10, "\uD83C\uDF89");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "span", 26);
    i0.ɵɵtext(12, "Congratulations");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "span", 27);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "span", 21);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.singleCouponText, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showDetailsLink);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r1.offerCompletedText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.adaText);
} }
function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 16);
    i0.ɵɵtemplate(2, ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_2_ng_container_2_Template, 13, 5, "ng-container", 0)(3, ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_2_ng_container_3_Template, 17, 4, "ng-container", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.isOfferCompleteVisible(ctx_r1.coupons[0]));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isOfferCompleteVisible(ctx_r1.coupons[0]));
} }
function ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_1_Template, 3, 2, "ng-container", 0)(2, ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_ng_container_2_Template, 4, 2, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.coupons[0].isClippable);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.coupons && ctx_r1.coupons.length > 0 && !ctx_r1.coupons[0].isClippable && ctx_r1.coupons[0].ecomDescription);
} }
function ProductCouponALV1Component_div_0_ng_container_3_div_2_span_6_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵlistener("click", function ProductCouponALV1Component_div_0_ng_container_3_div_2_span_6_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.setProductDetails("bogo-detail")); })("keyup.enter", function ProductCouponALV1Component_div_0_ng_container_3_div_2_span_6_Template_span_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.setProductDetails("bogo-detail")); });
    i0.ɵɵtext(1, "Details");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵattribute("aria-label", "Details for " + ctx_r1.bogoText + " offer for " + ctx_r1.getProductFullName());
} }
function ProductCouponALV1Component_div_0_ng_container_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28)(1, "div", 29);
    i0.ɵɵelement(2, "span", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 30)(4, "div", 31);
    i0.ɵɵtext(5);
    i0.ɵɵtemplate(6, ProductCouponALV1Component_div_0_ng_container_3_div_2_span_6_Template, 2, 1, "span", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 33)(8, "span", 34);
    i0.ɵɵtext(9, "\uD83C\uDF89");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "span", 26);
    i0.ɵɵtext(11, "Congratulations");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "span", 35);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "span", 21);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.bogoText, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showDetailsLink && (ctx_r1.configObj == null ? null : ctx_r1.configObj.programType) !== "1P_SNS");
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r1.offerCompletedText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.adaText);
} }
function ProductCouponALV1Component_div_0_ng_container_3_div_3_span_8_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 41);
    i0.ɵɵlistener("click", function ProductCouponALV1Component_div_0_ng_container_3_div_3_span_8_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.setProductDetails("bogo-detail")); })("keyup.enter", function ProductCouponALV1Component_div_0_ng_container_3_div_3_span_8_Template_span_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.setProductDetails("bogo-detail")); });
    i0.ɵɵtext(1, "Details");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵattribute("aria-label", "Details for " + ctx_r1.bogoText + " offer for " + ctx_r1.getProductFullName());
} }
function ProductCouponALV1Component_div_0_ng_container_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37)(1, "div", 38);
    i0.ɵɵelement(2, "span", 18);
    i0.ɵɵelementStart(3, "span", 26);
    i0.ɵɵtext(4, "Clip");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 30)(6, "div", 39);
    i0.ɵɵtext(7);
    i0.ɵɵtemplate(8, ProductCouponALV1Component_div_0_ng_container_3_div_3_span_8_Template, 2, 1, "span", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 33);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "span", 21);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.bogoText, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showDetailsLink && (ctx_r1.configObj == null ? null : ctx_r1.configObj.programType) !== "1P_SNS");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.bogoTextDetail);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.adaText);
} }
function ProductCouponALV1Component_div_0_ng_container_3_div_4_ng_container_2_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 45);
    i0.ɵɵlistener("click", function ProductCouponALV1Component_div_0_ng_container_3_div_4_ng_container_2_a_1_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r1 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r1.setProductDetails("coupon-list")); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵattribute("aria-description", ctx_r1.getProductFullName());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.availableCoupons);
} }
function ProductCouponALV1Component_div_0_ng_container_3_div_4_ng_container_2_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 45);
    i0.ɵɵlistener("click", function ProductCouponALV1Component_div_0_ng_container_3_div_4_ng_container_2_a_2_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r1 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r1.setProductDetails("coupon-list")); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵattribute("aria-description", ctx_r1.getProductFullName());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.clippedCompletedCoupons);
} }
function ProductCouponALV1Component_div_0_ng_container_3_div_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductCouponALV1Component_div_0_ng_container_3_div_4_ng_container_2_a_1_Template, 2, 2, "a", 44)(2, ProductCouponALV1Component_div_0_ng_container_3_div_4_ng_container_2_a_2_Template, 2, 2, "a", 44);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.offersClippedCounter === 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.offersClippedCounter > 0);
} }
function ProductCouponALV1Component_div_0_ng_container_3_div_4_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.availableCoupons);
} }
function ProductCouponALV1Component_div_0_ng_container_3_div_4_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.clippedCompletedCoupons);
} }
function ProductCouponALV1Component_div_0_ng_container_3_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ProductCouponALV1Component_div_0_ng_container_3_div_4_div_3_div_1_Template, 2, 1, "div", 46)(2, ProductCouponALV1Component_div_0_ng_container_3_div_4_div_3_div_2_Template, 2, 1, "div", 46);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.offersClippedCounter === 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.offersClippedCounter > 0);
} }
function ProductCouponALV1Component_div_0_ng_container_3_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵelement(1, "span", 43);
    i0.ɵɵtemplate(2, ProductCouponALV1Component_div_0_ng_container_3_div_4_ng_container_2_Template, 3, 2, "ng-container", 0)(3, ProductCouponALV1Component_div_0_ng_container_3_div_4_div_3_Template, 3, 2, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isClickableMultipleCoupons);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isClickableMultipleCoupons);
} }
function ProductCouponALV1Component_div_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductCouponALV1Component_div_0_ng_container_3_ng_container_1_Template, 3, 2, "ng-container", 0)(2, ProductCouponALV1Component_div_0_ng_container_3_div_2_Template, 16, 4, "div", 4)(3, ProductCouponALV1Component_div_0_ng_container_3_div_3_Template, 13, 4, "div", 5)(4, ProductCouponALV1Component_div_0_ng_container_3_div_4_Template, 4, 2, "div", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isSingleOffer());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isSingleBogoOffer() && ctx_r1.isOfferCompleteVisible(ctx_r1.product));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isSingleBogoOffer() && !ctx_r1.isOfferCompleteVisible(ctx_r1.product));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isMultipleOffer());
} }
function ProductCouponALV1Component_div_0_ng_container_4_ng_container_1_ng_container_1_ng_container_1_ng_container_1_span_9_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 54);
    i0.ɵɵlistener("click", function ProductCouponALV1Component_div_0_ng_container_4_ng_container_1_ng_container_1_ng_container_1_ng_container_1_span_9_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r12); const coupon_r13 = i0.ɵɵnextContext(3).$implicit; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.setProductDetails("offer-detail", coupon_r13)); })("keyup.enter", function ProductCouponALV1Component_div_0_ng_container_4_ng_container_1_ng_container_1_ng_container_1_ng_container_1_span_9_Template_span_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r12); const coupon_r13 = i0.ɵɵnextContext(3).$implicit; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.setProductDetails("offer-detail", coupon_r13)); });
    i0.ɵɵtext(1, "Details");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(7);
    i0.ɵɵattribute("aria-label", "Details for " + ctx_r1.singleCouponText + " coupon for " + ctx_r1.getProductFullName());
} }
function ProductCouponALV1Component_div_0_ng_container_4_ng_container_1_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 16)(2, "div", 17);
    i0.ɵɵelement(3, "span", 49);
    i0.ɵɵelementStart(4, "div", 50);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 51)(7, "div", 13);
    i0.ɵɵtext(8);
    i0.ɵɵtemplate(9, ProductCouponALV1Component_div_0_ng_container_4_ng_container_1_ng_container_1_ng_container_1_ng_container_1_span_9_Template, 2, 1, "span", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 53);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "span", 21);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const coupon_r13 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r1.clippedText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.singleCouponText, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showDetailsLink);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Add ", coupon_r13.minPurchaseQty, " Total for Offers");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.adaText);
} }
function ProductCouponALV1Component_div_0_ng_container_4_ng_container_1_ng_container_1_ng_container_1_ng_container_2_span_7_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 54);
    i0.ɵɵlistener("click", function ProductCouponALV1Component_div_0_ng_container_4_ng_container_1_ng_container_1_ng_container_1_ng_container_2_span_7_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r14); const coupon_r13 = i0.ɵɵnextContext(3).$implicit; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.setProductDetails("offer-detail", coupon_r13)); })("keyup.enter", function ProductCouponALV1Component_div_0_ng_container_4_ng_container_1_ng_container_1_ng_container_1_ng_container_2_span_7_Template_span_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r14); const coupon_r13 = i0.ɵɵnextContext(3).$implicit; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.setProductDetails("offer-detail", coupon_r13)); });
    i0.ɵɵtext(1, "Details");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(7);
    i0.ɵɵattribute("aria-label", "Details for " + ctx_r1.singleCouponText + " coupon for " + ctx_r1.getProductFullName());
} }
function ProductCouponALV1Component_div_0_ng_container_4_ng_container_1_ng_container_1_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 22)(2, "div", 55);
    i0.ɵɵelement(3, "span", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 51)(5, "div", 13);
    i0.ɵɵtext(6);
    i0.ɵɵtemplate(7, ProductCouponALV1Component_div_0_ng_container_4_ng_container_1_ng_container_1_ng_container_1_ng_container_2_span_7_Template, 2, 1, "span", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 57)(9, "span", 25);
    i0.ɵɵtext(10, "\uD83C\uDF89");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "span", 26);
    i0.ɵɵtext(12, "Congratulations");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "span", 27);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "span", 21);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.singleCouponText, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showDetailsLink);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r1.offerCompletedText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.adaText);
} }
function ProductCouponALV1Component_div_0_ng_container_4_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductCouponALV1Component_div_0_ng_container_4_ng_container_1_ng_container_1_ng_container_1_ng_container_1_Template, 14, 5, "ng-container", 0)(2, ProductCouponALV1Component_div_0_ng_container_4_ng_container_1_ng_container_1_ng_container_1_ng_container_2_Template, 17, 4, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const coupon_r13 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isOfferCompleteVisible(coupon_r13));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isOfferCompleteVisible(coupon_r13));
} }
function ProductCouponALV1Component_div_0_ng_container_4_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductCouponALV1Component_div_0_ng_container_4_ng_container_1_ng_container_1_ng_container_1_Template, 3, 2, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const coupon_r13 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.couponIsExpired(coupon_r13));
} }
function ProductCouponALV1Component_div_0_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductCouponALV1Component_div_0_ng_container_4_ng_container_1_ng_container_1_Template, 2, 1, "ng-container", 48);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.NDCCoupons);
} }
function ProductCouponALV1Component_div_0_ng_container_4_ng_container_2_ng_container_1_ng_container_1_span_7_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 62);
    i0.ɵɵlistener("click", function ProductCouponALV1Component_div_0_ng_container_4_ng_container_2_ng_container_1_ng_container_1_span_7_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r15); const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.setProductDetails("bogo-detail")); })("keyup.enter", function ProductCouponALV1Component_div_0_ng_container_4_ng_container_2_ng_container_1_ng_container_1_span_7_Template_span_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r15); const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.setProductDetails("bogo-detail")); });
    i0.ɵɵtext(1, "Details");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵattribute("aria-label", "Details for " + ctx_r1.bogoText + " offer for " + ctx_r1.getProductFullName());
} }
function ProductCouponALV1Component_div_0_ng_container_4_ng_container_2_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 37)(2, "div", 58);
    i0.ɵɵelement(3, "span", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 59)(5, "div", 39);
    i0.ɵɵtext(6);
    i0.ɵɵtemplate(7, ProductCouponALV1Component_div_0_ng_container_4_ng_container_2_ng_container_1_ng_container_1_span_7_Template, 2, 1, "span", 60);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 61);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "span", 21);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.bogoText, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showDetailsLink && (ctx_r1.configObj == null ? null : ctx_r1.configObj.programType) !== "1P_SNS");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.bogoTextDetail);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.adaText);
} }
function ProductCouponALV1Component_div_0_ng_container_4_ng_container_2_ng_container_1_ng_container_2_span_7_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 62);
    i0.ɵɵlistener("click", function ProductCouponALV1Component_div_0_ng_container_4_ng_container_2_ng_container_1_ng_container_2_span_7_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.setProductDetails("bogo-detail")); })("keyup.enter", function ProductCouponALV1Component_div_0_ng_container_4_ng_container_2_ng_container_1_ng_container_2_span_7_Template_span_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.setProductDetails("bogo-detail")); });
    i0.ɵɵtext(1, "Details");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵattribute("aria-label", "Details for " + ctx_r1.bogoText + " offer for " + ctx_r1.getProductFullName());
} }
function ProductCouponALV1Component_div_0_ng_container_4_ng_container_2_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 28)(2, "div", 63);
    i0.ɵɵelement(3, "span", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 59)(5, "div", 39);
    i0.ɵɵtext(6);
    i0.ɵɵtemplate(7, ProductCouponALV1Component_div_0_ng_container_4_ng_container_2_ng_container_1_ng_container_2_span_7_Template, 2, 1, "span", 60);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 64)(9, "span", 65);
    i0.ɵɵtext(10, "\uD83C\uDF89");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "span", 26);
    i0.ɵɵtext(12, "Congratulations");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "span", 35);
    i0.ɵɵtext(14, "Offer Complete!");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.bogoText, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showDetailsLink && (ctx_r1.configObj == null ? null : ctx_r1.configObj.programType) !== "1P_SNS");
} }
function ProductCouponALV1Component_div_0_ng_container_4_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductCouponALV1Component_div_0_ng_container_4_ng_container_2_ng_container_1_ng_container_1_Template, 12, 4, "ng-container", 0)(2, ProductCouponALV1Component_div_0_ng_container_4_ng_container_2_ng_container_1_ng_container_2_Template, 15, 2, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isOfferCompleteVisible(ctx_r1.product));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isOfferCompleteVisible(ctx_r1.product));
} }
function ProductCouponALV1Component_div_0_ng_container_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductCouponALV1Component_div_0_ng_container_4_ng_container_2_ng_container_1_Template, 3, 2, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.validateBogoTexts());
} }
function ProductCouponALV1Component_div_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductCouponALV1Component_div_0_ng_container_4_ng_container_1_Template, 2, 1, "ng-container", 0)(2, ProductCouponALV1Component_div_0_ng_container_4_ng_container_2_Template, 2, 1, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isMultipleNDCOffer());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isSingleBogoOffer());
} }
function ProductCouponALV1Component_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 2)(2, "div", 3);
    i0.ɵɵtemplate(3, ProductCouponALV1Component_div_0_ng_container_3_Template, 5, 4, "ng-container", 0)(4, ProductCouponALV1Component_div_0_ng_container_4_Template, 3, 2, "ng-container", 0);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.parentComponent !== "minicart" && ctx_r1.parentComponent !== "product-detail");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.parentComponent === "product-detail");
} }
function ProductCouponALV1Component_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 66);
} }
class ProductCouponALV1Component {
    set carouselTitle(carouselTitle) {
        this._carouselTitle = carouselTitle;
    }
    get carouselTitle() {
        return this._carouselTitle;
    }
    constructor(_commonService, _userInfoService, _elementRef, cartService, _utilService, _productCouponService, cartV2Service) {
        this._commonService = _commonService;
        this._userInfoService = _userInfoService;
        this._elementRef = _elementRef;
        this.cartService = cartService;
        this._utilService = _utilService;
        this._productCouponService = _productCouponService;
        this.cartV2Service = cartV2Service;
        // Decision inputs
        this.showDetailsLink = true;
        this.showOfferComplete = true;
        this.isClickableMultipleCoupons = true;
        this.includeOffer = false;
        this.productCouponDetails = new EventEmitter();
        this.singleCouponClip = new EventEmitter();
        this.coupons = [];
        this.availableOffersCounter = 0;
        this.offersClippedCounter = 0;
        this.isWYSIWYGEnabled = false;
        this.isValidCouponBOGO = false;
        this.clippedText = 'Clipped';
        this.offerCompletedText = 'Offer Complete!';
        this.personalizedPriceLabel = 'Personalized Price: ';
        // Boxtop modal variables
        this.showBoxtop = false;
        this.modalAttrName = 'modal';
        this.modalIdName = '#boxtop-modal';
        this.adaText = '';
        this.isProductCardV2 = false;
        // CMS BOGO texts
        this.bogoText = 'Buy 1 Get 1 Free - ';
        this.bogoTextDetail = 'Add 2 Total for Offer';
        // Multiple coupons texts
        this.someCompletedCouponsText = '<completed> of <counter> Offers Complete';
        this.allCompletedCouponsText = '<completed> Offers Complete';
        this.someClippedCouponsText = '<clipped> of <counter> Offers Clipped';
        this.someCouponsText = '<counter> Offers Available';
        this.availableCoupons = '';
    }
    ngOnInit() {
        this.isProductCardV2 = true;
        this.product.isBOGO = this.isBogoOffer();
        // get coupons from offers if is product carousel item
        if (this.productOffers && typeof this.productOffers['offers'] !== 'undefined' && this.productOffers['offers'] != null) {
            if (!this._commonService.objPageCoupons['offersByUpc'].hasOwnProperty(this.product.upc)) {
                this._commonService.objPageCoupons['offersByUpc'][this.product.upc] = [];
            }
            for (const offer in this.productOffers.offers) {
                if (this.productOffers.offers.hasOwnProperty(offer) && !this.couponIsExpired(offer)) {
                    this.coupons.push(this.productOffers.offers[offer]);
                    this._commonService.objPageCoupons['offers'][offer] = this.productOffers.offers[offer];
                    if (!this._commonService.objPageCoupons['offersByUpc'][this.product.upc].includes(offer)) {
                        this._commonService.objPageCoupons['offersByUpc'][this.product.upc].push(offer);
                    }
                }
            }
        }
        // get coupons from localStorage if empty
        if (this.coupons.length === 0 && !this.includeOffer) {
            this._processFromLocalStorage();
        }
        this._init();
        this._commonService.shopCouponRefresh.subscribe(isRefresh => {
            if (isRefresh) {
                this._processFromLocalStorage();
                const tempCoupons = JSON.parse(JSON.stringify(this.coupons));
                const tempNDCCoupons = JSON.parse(JSON.stringify(this.NDCCoupons));
                if (tempCoupons.length > 0) {
                    this.coupons = this.cartService.processOfferComplete(this.cartDetails, tempCoupons, this.product);
                }
                if (tempNDCCoupons.length > 0) {
                    this.NDCCoupons = this.cartService.processOfferComplete(this.cartDetails, tempNDCCoupons, this.product);
                }
                this.cartService.processBOGOComplete(this.cartDetails, this.product);
                this._init();
            }
        });
        // check and update statuses when cart is updated
        this._commonService.currentCartObj.subscribe(objCart => {
            const singleCart = this.cartV2Service.fetchCartDetailsFromResponse(objCart, this.cartV2Service.getCartName(this.configObj.programType));
            this.cartDetails = singleCart;
            this.isWYSIWYGEnabled = this.cartDetails['isWYSIWYGEnabled'];
            const tempCoupons = JSON.parse(JSON.stringify(this.coupons));
            const tempNDCCoupons = JSON.parse(JSON.stringify(this.NDCCoupons));
            if (tempCoupons.length > 0) {
                this.coupons = this.cartService.processOfferComplete(this.cartDetails, tempCoupons, this.product);
            }
            if (tempNDCCoupons.length > 0) {
                this.NDCCoupons = this.cartService.processOfferComplete(this.cartDetails, tempNDCCoupons, this.product);
            }
            this.cartService.processBOGOComplete(this.cartDetails, this.product);
            if (this.availableOffersCounter > 1) {
                this.setOfferCompleteText();
            }
        });
    }
    _init() {
        // check number of offers available
        this.coupons = this.coupons.filter(coupon => coupon.isClippable || (!coupon.isClippable && coupon.ecomDescription));
        this.availableOffersCounter = (this.coupons) ? this.coupons.length : 0;
        this.NDCCoupons = this.coupons.filter(coupon => coupon.isClippable === false);
        this.NDCCoupons = this.coupons.filter(coupon => coupon.isClippable === false && coupon.ecomDescription);
        if (this.isBogoOffer()) {
            this.availableOffersCounter = this.availableOffersCounter + 1;
        }
        // check number of offers clipped
        this.offersClippedCounter = (this.availableOffersCounter > 0) ? this._productCouponService.getOffersClipped(this.coupons) : 0;
        if (this.isBogoOffer()) {
            this.offersClippedCounter = this.offersClippedCounter + 1;
        }
        // set text for multiple coupons
        this.setOfferCompleteText();
        // set text for bogo cms
        this.setBogoText();
        // set text for single coupon
        if (this.availableOffersCounter === 1 && this.coupons.length === 1) {
            this.singleCouponText =
                this.coupons[0].offerPgm && this.coupons[0].offerPgm === 'PD'
                    ? 'Personalized Price: ' + this.coupons[0].ecomDescription
                    : this.coupons[0].ecomDescription;
            this.coupons[0].offerComplete = this.coupons[0].offerComplete ? this.coupons[0].offerComplete : false;
        }
        this.productDetails = {
            'product': this.product,
            'offerCounter': this.availableOffersCounter,
            'offerClipped': this.offersClippedCounter,
            'coupons': this.coupons
        };
        this.productCouponDetails.emit(this.productDetails);
        // check if the coupons are available
        this.isValidCouponBOGO = this.availableOffersCounter > 0
            || (this.isBogoOffer() && this._commonService.isProductPromoActive(this.product));
        // set text when all coupons are unclipped
        if (this.availableOffersCounter > 1) {
            this.availableCoupons = this.someCouponsText.replace('<counter>', this.availableOffersCounter.toString());
        }
    }
    /**
     * Helper function which sets BOGO CMS promo attributes.
     */
    setBogoText() {
        this.bogoText = this.product.promoDescription ? `${this.product.promoDescription}${this.configObj.programType !== '1P_SNS' ? '-' : ''}` : '';
        this.bogoTextDetail = this.product.promoText ? this.product.promoText : '';
    }
    /**
     * Helper function that validates bogoText and bogoTextDetail promo attributes string length and returns boolean.
     */
    validateBogoTexts() {
        if (this.bogoText.length > 0 && this.bogoTextDetail.length > 0) {
            return true;
        }
        return false;
    }
    setOfferCompleteText() {
        let completedCouponsLength = this.isWYSIWYGEnabled === true && this.coupons && this.coupons.length > 0
            ? this._productCouponService.getCouponsCompletedCounter(this.coupons)
            : 0;
        if (this.isBogoOffer() && this.product.offerComplete && this.product.offerComplete === true) {
            completedCouponsLength = completedCouponsLength + 1;
        }
        if (completedCouponsLength > 0) {
            if (completedCouponsLength === this.availableOffersCounter) {
                // all the offers are complete
                this.clippedCompletedCoupons = this.allCompletedCouponsText
                    .replace('<completed>', completedCouponsLength.toString());
            }
            else {
                // some offers are complete
                this.clippedCompletedCoupons = this.someCompletedCouponsText
                    .replace('<completed>', completedCouponsLength.toString())
                    .replace('<counter>', this.availableOffersCounter.toString());
            }
        }
        else {
            // show clipped coupons
            this.setSomeClippedCouponsText(this.offersClippedCounter, this.availableOffersCounter);
        }
    }
    /**
     * Set the text for multiple coupons
     *
     * @param clipped - number of clipped coupons/offers
     * @param counter - number of total coupons/offers
     */
    setSomeClippedCouponsText(clipped, counter) {
        this.clippedCompletedCoupons = this.someClippedCouponsText
            .replace('<clipped>', clipped.toString())
            .replace('<counter>', counter.toString());
    }
    /**
     * @return true or false if the product is a BOGO offer
     */
    isBogoOffer() {
        return (this.product.promoType === 'M' || this.product.promoType === 'B');
    }
    /**
     * Get the coupons based on parent component
     */
    _processFromLocalStorage() {
        let couponsResult = [];
        if (localStorage.getItem('abCoupons')) {
            couponsResult = this.parentComponent === 'minicart'
                ? this._commonService.getClippedCouponByUpc(this.product.upc).clippedCoupons
                : this._commonService.getCouponByUpc(this.product.upc);
        }
        else {
            const offers = [];
            if (this._commonService.objPageCoupons
                && this._commonService.objPageCoupons['offersByUpc']
                && this._commonService.objPageCoupons['offersByUpc'][this.product.upc]
                && this._commonService.objPageCoupons['offers']) {
                this._commonService.objPageCoupons['offersByUpc'][this.product.upc].forEach(offer => {
                    offers.push(this._commonService.objPageCoupons['offers'][offer]);
                });
            }
            couponsResult = this.parentComponent === 'minicart'
                ? offers.filter(offer => offer.status === 'C')
                : offers;
        }
        if (this.parentComponent === 'minicart') {
            this.coupons = this.getCouponsFromProduct(couponsResult);
        }
        else {
            this.coupons = couponsResult;
        }
    }
    getCouponsFromProduct(coupons) {
        let savingsAndClippedUnion = [];
        const clipped = this.product.clipped || [];
        let savings = this.product.savings || [];
        if (savings) {
            savings = savings.filter(coupon => coupon.display == true && coupon.source !== 'CMS');
        }
        // Unite coupons from savings and clipped
        savingsAndClippedUnion = [...clipped, ...savings].filter((set => (coupon) => set.has(coupon.offerId) ? false : set.add(coupon.offerId))(new Set())).map(obj => ({
            ...obj,
            status: 'C',
            offerId: obj.omsOfferId,
            ecomDescription: obj.displayOfferTxt,
            deleted: false
        }));
        // Unite coupons from savings+clipped and from localeStorage abCoupons, filter them to re
        const allCoupons = [...savingsAndClippedUnion, ...coupons].filter((set => (coupon) => set.has(coupon.offerId) ? false : set.add(coupon.offerId))(new Set()));
        return allCoupons;
    }
    couponIsExpired(coupon) {
        return this._productCouponService.isCouponExpired(coupon);
    }
    productPromoIsActive(product) {
        return this._commonService.isProductPromoActive(product);
    }
    /**
     * Clip coupon when only one is available
     */
    clipCoupon() {
        if (this.coupons[0]['offerSubPgm'] === '07' && (window['AB'].userInfo.boxTopAuth || !this._isRegistered())) {
            this.modalAttrName = '';
            this.modalIdName = '';
        }
        if (this._isRegistered()) {
            const storeId = window['AB']['userInfo']['branchId'];
            this._updateAnalyticsDataLayer();
            this._updateAnalyticsCarouselName();
            const analyticsData = {
                nativeElement: this._elementRef.nativeElement
            };
            this._productCouponService.clipCoupon(this.coupons[0], storeId, null, analyticsData).subscribe(response => {
                if (response && response['items'] && response['items'][0] && response['items'][0]['status'] === 1) {
                    this.offersClippedCounter = 1;
                    setTimeout(() => {
                        $('#clippedCoupon' + this.coupons[0].offerId).focus();
                        this.adaText = 'This coupon has been clipped.';
                    }, 100);
                    setTimeout(() => {
                        this.adaText = '';
                    }, 500);
                    this.singleCouponClip.emit(this.productDetails);
                }
            });
        }
        else {
            window['AB']['COMMON'].showSignInModal_OTP(window.location.href);
        }
    }
    /**
     * Analytics method for updating productInfo
     */
    _updateAnalyticsDataLayer() {
        if (window['AB'] && window['AB']['DATALAYER']) {
            const analyticsCarouselTitle = this._carouselTitle ||
                window['AB']['DATALAYER'].getAnalyticsCarouselTitle(this._elementRef.nativeElement);
            window['AB']['DATALAYER'].productInfo({
                id: this.productDetails.product.id,
                name: this.productDetails.product.name,
                units: this.productDetails.product.units,
                listPrice: this.productDetails.product.price,
                basePrice: this.productDetails.product.basePrice,
                carouselSection: analyticsCarouselTitle || '',
                pricingType: this.productDetails.product.promoDescriptionVal || '',
                couponID: this.productDetails.coupons.filter(offer => offer.status === 'C').map(offer => offer.offerId).toString(),
                couponFlag: this.productDetails.offerCounter,
                couponClipped: this.offersClippedCounter,
                aisleId: this.productDetails.product.aisleId,
                upc: this.productDetails.product.upc
            });
        }
    }
    /**
     * Analytics method for sending the offer info with the linkClick event
     * param offerType
     * param offerName
     */
    _updateAnalyticsLinkClick(offerType, offerName) {
        if (window['AB'] && window['AB']['DATALAYER']) {
            if (offerName) {
                window['AB']['DATALAYER'].setLinkClickOfferDrawer(offerType, offerName, this._elementRef.nativeElement);
            }
            else {
                let multipleText = '';
                if (this.offersClippedCounter === 0) {
                    multipleText = `${this.availableOffersCounter} Coupons Available`;
                    window['AB']['DATALAYER'].setLinkClickOfferDrawer(offerType, multipleText, this._elementRef.nativeElement);
                }
                else if (this.offersClippedCounter > 0) {
                    multipleText = `${this.offersClippedCounter} of ${this.availableOffersCounter} Coupons Clipped`;
                    window['AB']['DATALAYER'].setLinkClickOfferDrawer(offerType, multipleText, this._elementRef.nativeElement);
                }
            }
        }
    }
    _updateAnalyticsModalViewSNS(name) {
        if (window['AB'] && window['AB']['DATALAYER']) {
            window['AB']['DATALAYER'].setModalViewEvents(name);
        }
    }
    /**
     * Analytics method for updating the carousel name
     */
    _updateAnalyticsCarouselName() {
        if (window['AB']['DATALAYER'] && this._carouselTitle) {
            window['AB']['DATALAYER'].setCarouselName('shop|' + this._carouselTitle);
        }
    }
    setProductDetails(drawerType, coupon) {
        //Check if 1P_SNS programType is set and emit event else do default behavior
        if (this.configObj.programType === '1P_SNS') {
            switch (drawerType) {
                case 'offer-detail':
                    this._commonService.dispatchSnsOneTimeEvent('singleCoupon', { coupons: this.coupons[0] });
                    this._updateAnalyticsModalViewSNS('offer-details-j4u-productcards|view');
                    break;
                case 'coupon-list':
                    this._commonService.dispatchSnsOneTimeEvent('multipleCoupons', { product: this.product });
                    this._updateAnalyticsModalViewSNS('offer-details-multiple-productcards|view');
                    break;
            }
        }
        else {
            let objDrawerData = {};
            // reset name property to default value to properly display the tooltip.
            if (drawerType === 'coupon-list') {
                objDrawerData = {
                    type: drawerType,
                    couponList: this.coupons,
                    product: this.product
                };
                this._updateAnalyticsLinkClick('offer-drawer-multiple-productcards', null);
            }
            else if (drawerType === 'offer-detail') {
                if (this.parentComponent && this.parentComponent === 'minicart') {
                    objDrawerData = {
                        type: drawerType,
                        coupon: coupon ? coupon : this.coupons[0],
                        product: this.product,
                        triggeredElement: 'mini-cart'
                    };
                    this._updateAnalyticsLinkClick('offer-drawer-j4u-minicart', this.singleCouponText);
                }
                else {
                    if (this.parentComponent && this.parentComponent === 'product-detail') {
                        objDrawerData = {
                            type: drawerType,
                            coupon,
                            product: this.product,
                            triggeredElement: 'single-coupon-product-card'
                        };
                    }
                    else {
                        objDrawerData = {
                            type: drawerType,
                            coupon: this.coupons[0],
                            product: this.product,
                            triggeredElement: 'single-coupon-product-card'
                        };
                    }
                    this._updateAnalyticsLinkClick('offer-drawer-j4u-productcards', this.singleCouponText);
                }
            }
            else if (drawerType === 'bogo-detail') {
                if (this.parentComponent && this.parentComponent === 'minicart') {
                    objDrawerData = {
                        type: drawerType,
                        product: this.product,
                        triggeredElement: 'mini-cart'
                    };
                    this._updateAnalyticsLinkClick('offer-drawer-bogo-minicart', this.bogoText);
                }
                else {
                    objDrawerData = {
                        type: drawerType,
                        product: this.product,
                        triggeredElement: 'single-coupon-product-card'
                    };
                    this._updateAnalyticsLinkClick('offer-drawer-bogo-productcards', this.bogoText);
                }
            }
            objDrawerData = { ...objDrawerData, configObj: this.configObj };
            this._commonService.rightDrawerSource.next(objDrawerData);
        }
    }
    openJ4UModal(event) {
        if (this.couponCalledBy !== 'c-products-by-upc' && this.couponCalledBy !== 'offer') {
            const clickedCouponId = event.target.id;
            $('#offerDetailModal').find('.modal-body').load(event.target.pathname, () => {
                this._commonService.initJ4UModal();
                $('#offerDetailModal #loadingConMedium').hide();
                $('#offerDetailModal').modal({ show: true, backdrop: 'static' }, $(`#${clickedCouponId}`));
            });
        }
        else {
            $('html, body').animate({ scrollTop: 0 }, 'slow');
        }
    }
    getProductFullName() {
        let fullName = '';
        if (this.productDetails && this.productDetails.product) {
            fullName = this.productDetails.product.fullName && this.productDetails.product.fullName.length ?
                this.productDetails.product.fullName : this.productDetails.product.name;
        }
        return fullName;
    }
    /**
     * Method for checking if there is a single offer and is a BOGO
     * @return true or false if token is active and use is authorized
     */
    _isRegistered() {
        return (this._utilService.isTokenActive() && this._userInfoService.isAuthorized());
    }
    /**
     * Method for checking if there is a single offer and is a coupon
     *
     * @return true or false based on the number of available offers
     */
    isSingleOffer() {
        return this.parentComponent === 'minicart'
            ? this.availableOffersCounter === 1 && !this.product.isBOGO
            : (this.availableOffersCounter === 1 && this.isProductCardV2 === false)
                || (this.availableOffersCounter === 1 && this.isProductCardV2 === true && !this.product.isBOGO);
    }
    /**
     * Method for checking if there is a single offer and is a BOGO
     *
     * @return true or false if the number of available offers is 1 and is a BOGO
     */
    isSingleBogoOffer() {
        return this.parentComponent === 'minicart' || this.parentComponent === 'product-detail'
            ? this.product.isBOGO && this.productPromoIsActive(this.product)
            : this.availableOffersCounter === 1 && this.isProductCardV2 && this.product.isBOGO && this.productPromoIsActive(this.product);
    }
    /**
     * Method for cheching if there are multiple offers to show
     *
     * @return true or false based on the number of available offers
     */
    isMultipleOffer() {
        return this.availableOffersCounter > 1;
    }
    /**
     * Method for cheching if there are multiple NDC offers to show
     *
     * @return true or false based on the number of available offers
     */
    isMultipleNDCOffer() {
        return this.NDCCoupons.length > 0;
    }
    /**
     * Method which is checking if the offer complete has to be shown
     *
     * @param item - this can be product, coupon or any other object with offerComplete
     * @return true or false based on the item and the showOfferComplete input
     */
    isOfferCompleteVisible(item) {
        if (this.isSingleOffer()) {
            return this.isCartProduct() && item.offerComplete && this.showOfferComplete;
        }
        else {
            return item.offerComplete && this.showOfferComplete;
        }
    }
    isCartProduct() {
        const cartItemsList = this.cartDetails.cartItems;
        if (cartItemsList) {
            if (this.product.id) {
                return cartItemsList.find((item) => item.itemId.toString() === this.product.id.toString());
            }
            else if (this.product.itemId) {
                return cartItemsList.find((item) => item.itemId.toString() === this.product.itemId.toString());
            }
        }
        return false;
    }
    static { this.ɵfac = function ProductCouponALV1Component_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ProductCouponALV1Component)(i0.ɵɵdirectiveInject(i1.CommonService), i0.ɵɵdirectiveInject(i1.UserInfoService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.CartService), i0.ɵɵdirectiveInject(i1.UtilService), i0.ɵɵdirectiveInject(i1.ProductCouponService), i0.ɵɵdirectiveInject(i1.CartV2Service)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProductCouponALV1Component, selectors: [["product-coupon-al-v1"]], inputs: { product: "product", parentComponent: "parentComponent", productOffers: "productOffers", couponCalledBy: "couponCalledBy", showDetailsLink: "showDetailsLink", showOfferComplete: "showOfferComplete", isClickableMultipleCoupons: "isClickableMultipleCoupons", configObj: "configObj", includeOffer: "includeOffer", carouselTitle: "carouselTitle" }, outputs: { productCouponDetails: "productCouponDetails", singleCouponClip: "singleCouponClip" }, features: [i0.ɵɵProvidersFeature([ProductCouponService])], decls: 2, vars: 2, consts: [[4, "ngIf"], ["class", "sm-empty-height", 4, "ngIf"], [1, "product-coupon-wrapper-v3"], [1, "coupon-container"], ["class", "bogo-coupon bogo-coupon--offer-completed", 4, "ngIf"], ["class", "bogo-coupon bogo-coupon--offer-not-completed", 4, "ngIf"], ["aria-live", "polite", "class", "multiple-coupon", 4, "ngIf"], ["class", "single-coupon single-coupon--unclipped", 4, "ngIf"], ["class", "single-coupon single-coupon--clipped", 4, "ngIf"], [1, "single-coupon", "single-coupon--unclipped"], [1, "single-coupon__clip-button"], [3, "click", "id"], [1, "single-coupon__details"], [1, "single-coupon__details-text"], ["class", "single-coupon__details-text__link", "tabindex", "0", "role", "button", 3, "click", "keyup.enter", 4, "ngIf"], ["tabindex", "0", "role", "button", 1, "single-coupon__details-text__link", 3, "click", "keyup.enter"], [1, "single-coupon", "single-coupon--clipped"], [1, "single-coupon__clipped-icon"], ["aria-hidden", "true", 1, "svg-coupon-clipped-icon"], [1, "single-coupon__clipped-icon__info", "single-coupon__clipped-icon__info--small"], [1, "single-coupon__details-info"], ["aria-live", "polite", 1, "sr-only"], [1, "single-coupon", "single-coupon--offer-completed"], [1, "single-coupon__tick-icon"], [1, "svg-coupon-tick-mark"], ["aria-hidden", "true", 1, "single-coupon__details-info__party-icon"], [1, "sr-only"], [1, "single-coupon__details-info__text"], [1, "bogo-coupon", "bogo-coupon--offer-completed"], [1, "bogo-coupon__tick-icon"], ["aria-live", "polite", 1, "bogo-coupon__details"], ["data-qa", "rw-crt-itm-bg-cpn-clppd-offr", 1, "bogo-coupon__details-text"], ["class", "bogo-coupon__details-text__link", "data-qa", "rw-crt-itm-bg-cpn-dtils-lnk", "tabindex", "0", "role", "button", 3, "click", "keyup.enter", 4, "ngIf"], [1, "bogo-coupon__details-info"], ["aria-hidden", "true", 1, "bogo-coupon__details-info__party-icon"], [1, "bogo-coupon__details-info__text"], ["data-qa", "rw-crt-itm-bg-cpn-dtils-lnk", "tabindex", "0", "role", "button", 1, "bogo-coupon__details-text__link", 3, "click", "keyup.enter"], [1, "bogo-coupon", "bogo-coupon--offer-not-completed"], [1, "bogo-coupon__clipped-icon"], [1, "bogo-coupon__details-text"], ["class", "bogo-coupon__details-text__link", "tabindex", "0", "role", "button", 3, "click", "keyup.enter", 4, "ngIf"], ["tabindex", "0", "role", "button", 1, "bogo-coupon__details-text__link", 3, "click", "keyup.enter"], ["aria-live", "polite", 1, "multiple-coupon"], ["aria-hidden", "true", 1, "svg-scissor"], ["href", "javascript:void(0);", "role", "button", "class", "multiple-coupon__text", 3, "click", 4, "ngIf"], ["href", "javascript:void(0);", "role", "button", 1, "multiple-coupon__text", 3, "click"], ["class", "multiple-coupon__not-clickable", 4, "ngIf"], [1, "multiple-coupon__not-clickable"], [4, "ngFor", "ngForOf"], ["aria-hidden", "true", "data-qa", "svg-icn-deal", 1, "svg-checkedSucces"], ["data-qa", "sngl-cpn-clppd-txt", 1, "single-coupon__clipped-icon__info", "single-coupon__clipped-icon__info--small"], ["data-qa", "sngl-cpn-dtls-lnk", 1, "single-coupon__details"], ["class", "single-coupon__details-text__link", "role", "button", "tabindex", "0", "data-qa", "dtls-for-cpn", 3, "click", "keyup.enter", 4, "ngIf"], ["data-qa", "sngl-cpn-clppd-offr", 1, "single-coupon__details-info"], ["role", "button", "tabindex", "0", "data-qa", "dtls-for-cpn", 1, "single-coupon__details-text__link", 3, "click", "keyup.enter"], ["data-qa", "sngl-cpn-clppd-icn", 1, "single-coupon__tick-icon"], ["aria-hidden", "true", 1, "svg-checkedSucces"], ["data-qa", "cpn-clppd-offr-cmpltd", 1, "single-coupon__details-info"], ["data-qa", "w-crt-itm-bg-cpn-clppd-icon", 1, "bogo-coupon__clipped-icon"], ["data-qa", "bg-cpn-clppd-dtls", 1, "bogo-coupon__details"], ["data-qa", "rw-crt-itm-bg-cpn-dtils-lnk", "class", "bogo-coupon__details-text__link", "role", "button", "tabindex", "0", 3, "click", "keyup.enter", 4, "ngIf"], ["data-qa", "bgo-cpn-clppd-offr", 1, "bogo-coupon__details-info"], ["data-qa", "rw-crt-itm-bg-cpn-dtils-lnk", "role", "button", "tabindex", "0", 1, "bogo-coupon__details-text__link", 3, "click", "keyup.enter"], ["data-qa", "w-crt-itm-bg-cpn-clppd-icon", 1, "bogo-coupon__tick-icon"], ["data-qa", "bg-cpn-clppd-offr-cmpltd", 1, "bogo-coupon__details-info"], ["aria-hidden", "true", "data-qa", "bg-cpn-clppd-offr-cmpltd-prty-icon", 1, "bogo-coupon__details-info__party-icon"], [1, "sm-empty-height"]], template: function ProductCouponALV1Component_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ProductCouponALV1Component_div_0_Template, 5, 2, "div", 0)(1, ProductCouponALV1Component_div_1_Template, 1, 0, "div", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.isValidCouponBOGO);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.coupons);
        } }, dependencies: [i2.NgForOf, i2.NgIf], encapsulation: 2 }); }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProductCouponALV1Component, factory: ProductCouponALV1Component.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductCouponALV1Component, [{
        type: Component,
        args: [{ selector: 'product-coupon-al-v1', providers: [ProductCouponService], template: "<div *ngIf=\"isValidCouponBOGO\">\n    <div class=\"product-coupon-wrapper-v3\">\n        <div class=\"coupon-container\">\n                <!-- Product item offers -->\n                <ng-container *ngIf=\"parentComponent !== 'minicart' && parentComponent !== 'product-detail'\">\n                    <!-- Single offer -->\n                    <ng-container *ngIf=\"isSingleOffer()\">\n                        <ng-container *ngIf=\"coupons[0].isClippable\">\n                            <div *ngIf=\"coupons[0].status === 'U' || coupons[0].deleted === true\"\n                                class=\"single-coupon single-coupon--unclipped\">\n                                <div class=\"single-coupon__clip-button\">\n                                    <button [attr.data-toggle]=\"showBoxtop && coupons[0].offerSubPgm === '07' ? modalAttrName : null\"\n                                        [attr.data-target]=\"showBoxtop && coupons[0].offerSubPgm === '07' ? modalIdName : null\"\n                                        (click)=\"clipCoupon()\" id=\"couponAddBtn{{coupons[0].offerId}}\"\n                                        attr.aria-label=\"{{'Clip coupon for ' + singleCouponText + ' for ' + getProductFullName()}}\">\n                                    </button>\n                                </div>\n                                <div class=\"single-coupon__details\">\n                                    <div class=\"single-coupon__details-text\"> {{singleCouponText}} <span *ngIf=\"showDetailsLink\" class=\"single-coupon__details-text__link\"\n                                            (click)=\"setProductDetails('offer-detail')\"\n                                            (keyup.enter)=\"setProductDetails('offer-detail')\" tabindex=\"0\" role=\"button\"\n                                            attr.aria-label=\"{{'Details for ' + singleCouponText + ' coupon for ' + getProductFullName()}}\">Details</span>\n                                    </div>\n                                </div>\n                            </div>\n                            <div *ngIf=\"coupons[0].status === 'C' && coupons[0].deleted === false\"\n                                class=\"single-coupon single-coupon--clipped\">\n                                <ng-container *ngIf=\"!isOfferCompleteVisible(coupons[0])\">\n                                    <div class=\"single-coupon__clipped-icon\">\n                                        <span aria-hidden=\"true\" class=\"svg-coupon-clipped-icon\"></span>\n                                        <div class=\"single-coupon__clipped-icon__info single-coupon__clipped-icon__info--small\">{{clippedText}}</div>\n                                    </div>\n                                    <div class=\"single-coupon__details\">\n                                        <div class=\"single-coupon__details-text\"> {{singleCouponText}} <span *ngIf=\"showDetailsLink\"\n                                                class=\"single-coupon__details-text__link\" (click)=\"setProductDetails('offer-detail')\"\n                                                (keyup.enter)=\"setProductDetails('offer-detail')\" tabindex=\"0\" role=\"button\"\n                                                attr.aria-label=\"{{'Details for ' + singleCouponText + ' coupon for ' + getProductFullName()}}\">Details</span>\n                                        </div>\n                                        <div class=\"single-coupon__details-info\">Add\n                                            {{coupons[0].minPurchaseQty}} Total for Offer\n                                        </div>\n                                        <span class=\"sr-only\" aria-live=\"polite\">{{adaText}}</span>\n                                    </div>\n                                </ng-container>\n                                <ng-container *ngIf=\"isOfferCompleteVisible(coupons[0])\">\n                                    <div class=\"single-coupon single-coupon--offer-completed\">\n                                        <div class=\"single-coupon__tick-icon\">\n                                            <span class=\"svg-coupon-tick-mark\"></span>\n                                        </div>\n                                        <div class=\"single-coupon__details\">\n                                            <div class=\"single-coupon__details-text\"> {{singleCouponText}} <span *ngIf=\"showDetailsLink\"\n                                                    class=\"single-coupon__details-text__link\" (click)=\"setProductDetails('offer-detail')\"\n                                                    (keyup.enter)=\"setProductDetails('offer-detail')\" tabindex=\"0\" role=\"button\"\n                                                    attr.aria-label=\"{{'Details for ' + singleCouponText + ' coupon for ' + getProductFullName()}}\">Details</span>\n                                            </div>\n                                            <div class=\"single-coupon__details-info\">\n                                                <span aria-hidden=\"true\" class=\"single-coupon__details-info__party-icon\">\uD83C\uDF89</span>\n                                                <span class=\"sr-only\">Congratulations</span>\n                                                <span class=\"single-coupon__details-info__text\">{{offerCompletedText}}</span>\n                                            </div>\n                                            <span class=\"sr-only\" aria-live=\"polite\">{{adaText}}</span>\n                                        </div>\n                                    </div>\n                                </ng-container>\n                            </div>\n                        </ng-container>\n\n                        <ng-container *ngIf=\"coupons && coupons.length > 0 && !coupons[0].isClippable && coupons[0].ecomDescription\">\n                            <div class=\"single-coupon single-coupon--clipped\">\n                                <ng-container *ngIf=\"!isOfferCompleteVisible(coupons[0])\">\n                                    <div class=\"single-coupon__clipped-icon\">\n                                        <span aria-hidden=\"true\" class=\"svg-coupon-clipped-icon\"></span>\n                                        <div class=\"single-coupon__clipped-icon__info single-coupon__clipped-icon__info--small\">{{clippedText}}</div>\n                                    </div>\n                                    <div class=\"single-coupon__details\">\n                                        <div class=\"single-coupon__details-text\"> {{singleCouponText}} <span *ngIf=\"showDetailsLink && configObj?.programType !== '1P_SNS'\"\n                                                class=\"single-coupon__details-text__link\" (click)=\"setProductDetails('offer-detail')\"\n                                                (keyup.enter)=\"setProductDetails('offer-detail')\" tabindex=\"0\" role=\"button\"\n                                                attr.aria-label=\"{{'Details for ' + singleCouponText + ' coupon for ' + getProductFullName()}}\">Details</span>\n                                        </div>\n                                        <div class=\"single-coupon__details-info\">Add\n                                            {{coupons[0].minPurchaseQty}} Total for Offer\n                                        </div>\n                                        <span class=\"sr-only\" aria-live=\"polite\">{{adaText}}</span>\n                                    </div>\n                                </ng-container>\n                                <ng-container *ngIf=\"isOfferCompleteVisible(coupons[0])\">\n                                    <div class=\"single-coupon single-coupon--offer-completed\">\n                                        <div class=\"single-coupon__tick-icon\">\n                                            <span class=\"svg-coupon-tick-mark\"></span>\n                                        </div>\n                                        <div class=\"single-coupon__details\">\n                                            <div class=\"single-coupon__details-text\"> {{singleCouponText}} <span *ngIf=\"showDetailsLink\"\n                                                    class=\"single-coupon__details-text__link\" (click)=\"setProductDetails('offer-detail')\"\n                                                    (keyup.enter)=\"setProductDetails('offer-detail')\" tabindex=\"0\" role=\"button\"\n                                                    attr.aria-label=\"{{'Details for ' + singleCouponText + ' coupon for ' + getProductFullName()}}\">Details</span>\n                                            </div>\n                                            <div class=\"single-coupon__details-info\">\n                                                <span aria-hidden=\"true\" class=\"single-coupon__details-info__party-icon\">\uD83C\uDF89</span>\n                                                <span class=\"sr-only\">Congratulations</span>\n                                                <span class=\"single-coupon__details-info__text\">{{offerCompletedText}}</span>\n                                            </div>\n                                            <span class=\"sr-only\" aria-live=\"polite\">{{adaText}}</span>\n                                        </div>\n                                    </div>\n                                </ng-container>\n                            </div>\n                        </ng-container>\n                    </ng-container>\n\n                    <!-- Display single offer on single line if promotype is equal to M or B due to spacing in new product cards -->\n                    <!-- Offer Completed -->\n                    <div *ngIf=\"isSingleBogoOffer() && isOfferCompleteVisible(product)\" class=\"bogo-coupon bogo-coupon--offer-completed\"> \n                        <div class=\"bogo-coupon__tick-icon\">\n                            <span class=\"svg-coupon-tick-mark\"></span>\n                        </div>\n                        <div aria-live=\"polite\" class=\"bogo-coupon__details\">\n                            <div class=\"bogo-coupon__details-text\" data-qa=\"rw-crt-itm-bg-cpn-clppd-offr\"> {{bogoText}} <span *ngIf=\"showDetailsLink && configObj?.programType !== '1P_SNS'\" class=\"bogo-coupon__details-text__link\" data-qa=\"rw-crt-itm-bg-cpn-dtils-lnk\"\n                                    (click)=\"setProductDetails('bogo-detail')\" (keyup.enter)=\"setProductDetails('bogo-detail')\"\n                                    tabindex=\"0\" role=\"button\"\n                                    attr.aria-label=\"{{'Details for ' + bogoText + ' offer for ' + getProductFullName()}}\">Details</span>\n                            </div>\n                            <div class=\"bogo-coupon__details-info\">\n                                <span aria-hidden=\"true\" class=\"bogo-coupon__details-info__party-icon\">\uD83C\uDF89</span>\n                                <span class=\"sr-only\">Congratulations</span>\n                                <span class=\"bogo-coupon__details-info__text\">{{offerCompletedText}}</span>\n                            </div>\n                            <span class=\"sr-only\" aria-live=\"polite\">{{adaText}}</span>\n                        </div>\n                    </div>\n                    <!-- Offer Not Completed -->\n                    <div *ngIf=\"isSingleBogoOffer() && !isOfferCompleteVisible(product)\" class=\"bogo-coupon bogo-coupon--offer-not-completed\">\n                        <div class=\"bogo-coupon__clipped-icon\">\n                            <span aria-hidden=\"true\" class=\"svg-coupon-clipped-icon\"></span>\n                            <span class=\"sr-only\">Clip</span>\n                        </div>\n                        <div aria-live=\"polite\" class=\"bogo-coupon__details\">\n                            <div class=\"bogo-coupon__details-text\"> {{bogoText}} <span *ngIf=\"showDetailsLink && configObj?.programType !== '1P_SNS'\" class=\"bogo-coupon__details-text__link\"\n                                    (click)=\"setProductDetails('bogo-detail')\" (keyup.enter)=\"setProductDetails('bogo-detail')\" tabindex=\"0\"\n                                    role=\"button\"\n                                    attr.aria-label=\"{{'Details for ' + bogoText + ' offer for ' + getProductFullName()}}\">Details</span>\n                            </div>\n                            <div class=\"bogo-coupon__details-info\">{{bogoTextDetail}}</div>\n                            <span class=\"sr-only\" aria-live=\"polite\">{{adaText}}</span>\n                        </div>\n                    </div>\n\n                    <!-- Multiple offers -->\n                    <div aria-live=\"polite\" *ngIf=\"isMultipleOffer()\" class=\"multiple-coupon\">\n\n                        <span aria-hidden=\"true\" class=\"svg-scissor\"></span>\n\n                        <ng-container *ngIf=\"isClickableMultipleCoupons\">\n                            <a *ngIf=\"offersClippedCounter === 0\" href=\"javascript:void(0);\" role=\"button\" class=\"multiple-coupon__text\"\n                                (click)=\"setProductDetails('coupon-list')\" attr.aria-description=\"{{getProductFullName()}}\">{{availableCoupons}}</a>\n                            <a *ngIf=\"offersClippedCounter > 0\" href=\"javascript:void(0);\" role=\"button\"\n                                class=\"multiple-coupon__text\"\n                                (click)=\"setProductDetails('coupon-list')\" attr.aria-description=\"{{getProductFullName()}}\">{{clippedCompletedCoupons}}</a>\n                        </ng-container>\n\n                        <div *ngIf=\"!isClickableMultipleCoupons\">\n                            <div *ngIf=\"offersClippedCounter === 0\" class=\"multiple-coupon__not-clickable\">{{availableCoupons}}</div>\n                            <div *ngIf=\"offersClippedCounter > 0\" class=\"multiple-coupon__not-clickable\">{{clippedCompletedCoupons}}</div>\n                        </div>\n                    </div>\n                </ng-container>\n\n            <!-- PDP offers -->\n            <ng-container *ngIf=\"parentComponent === 'product-detail'\">\n                <ng-container *ngIf=\"isMultipleNDCOffer()\">\n                    <ng-container *ngFor=\"let coupon of NDCCoupons\">\n                        <ng-container *ngIf=\"!couponIsExpired(coupon)\">\n                            <ng-container *ngIf=\"!isOfferCompleteVisible(coupon)\">\n                                <div class=\"single-coupon single-coupon--clipped\">\n                                    <div class=\"single-coupon__clipped-icon\">\n                                        <span aria-hidden=\"true\" data-qa=\"svg-icn-deal\" class=\"svg-checkedSucces\"></span>\n                                        <div data-qa=\"sngl-cpn-clppd-txt\" class=\"single-coupon__clipped-icon__info single-coupon__clipped-icon__info--small\">{{clippedText}}</div>\n                                    </div>\n                                    <div class=\"single-coupon__details\" data-qa=\"sngl-cpn-dtls-lnk\">\n                                        <div class=\"single-coupon__details-text\"> {{singleCouponText}}\n                                            <span *ngIf=\"showDetailsLink\" class=\"single-coupon__details-text__link\"\n                                                (click)=\"setProductDetails('offer-detail', coupon)\" (keyup.enter)=\"setProductDetails('offer-detail', coupon)\"\n                                                role=\"button\" tabindex=\"0\" data-qa=\"dtls-for-cpn\"\n                                                attr.aria-label=\"{{'Details for ' + singleCouponText + ' coupon for ' + getProductFullName()}}\">Details</span>\n                                        </div>\n                                        <div class=\"single-coupon__details-info\" data-qa=\"sngl-cpn-clppd-offr\">Add {{coupon.minPurchaseQty}} Total for Offers</div>\n                                        <span aria-live=\"polite\" class=\"sr-only\">{{adaText}}</span>\n                                    </div>\n                                </div>\n                            </ng-container>\n\n                            <ng-container *ngIf=\"isOfferCompleteVisible(coupon)\">\n                                <div class=\"single-coupon single-coupon--offer-completed\">\n                                    <div class=\"single-coupon__tick-icon\" data-qa=\"sngl-cpn-clppd-icn\">\n                                        <span aria-hidden=\"true\" class=\"svg-checkedSucces\"></span>\n                                    </div>\n                                    <div class=\"single-coupon__details\" data-qa=\"sngl-cpn-dtls-lnk\">\n                                        <div class=\"single-coupon__details-text\"> {{singleCouponText}} <span *ngIf=\"showDetailsLink\"\n                                                class=\"single-coupon__details-text__link\" (click)=\"setProductDetails('offer-detail', coupon)\"\n                                                (keyup.enter)=\"setProductDetails('offer-detail', coupon)\" role=\"button\" tabindex=\"0\" data-qa=\"dtls-for-cpn\"\n                                                attr.aria-label=\"{{'Details for ' + singleCouponText + ' coupon for ' + getProductFullName()}}\">Details</span>\n                                        </div>\n                                        <div class=\"single-coupon__details-info\" data-qa=\"cpn-clppd-offr-cmpltd\">\n                                            <span aria-hidden=\"true\" class=\"single-coupon__details-info__party-icon\">\uD83C\uDF89</span>\n                                            <span class=\"sr-only\">Congratulations</span>\n                                            <span class=\"single-coupon__details-info__text\">{{offerCompletedText}}</span>\n                                        </div>\n                                        <span aria-live=\"polite\" class=\"sr-only\">{{adaText}}</span>\n                                    </div>\n                                </div>\n                            </ng-container>\n                        </ng-container>\n                    </ng-container>\n                </ng-container>\n\n                <ng-container *ngIf=\"isSingleBogoOffer()\">\n                    <ng-container *ngIf=\"validateBogoTexts()\">\n                        <ng-container *ngIf=\"!isOfferCompleteVisible(product)\">\n                            <div class=\"bogo-coupon bogo-coupon--offer-not-completed\">\n                                <div class=\"bogo-coupon__clipped-icon\" data-qa=\"w-crt-itm-bg-cpn-clppd-icon\">\n                                    <span aria-hidden=\"true\" class=\"svg-checkedSucces\"></span>\n                                </div>\n                                <div class=\"bogo-coupon__details\" data-qa=\"bg-cpn-clppd-dtls\">\n                                    <div class=\"bogo-coupon__details-text\"> {{bogoText}} <span *ngIf=\"showDetailsLink && configObj?.programType !== '1P_SNS'\" data-qa=\"rw-crt-itm-bg-cpn-dtils-lnk\"\n                                                                                               (click)=\"setProductDetails('bogo-detail')\" (keyup.enter)=\"setProductDetails('bogo-detail')\"\n                                                                                               class=\"bogo-coupon__details-text__link\" role=\"button\" tabindex=\"0\"\n                                                                                               attr.aria-label=\"{{'Details for ' + bogoText + ' offer for ' + getProductFullName()}}\">Details</span>\n                                    </div>\n                                    <div data-qa=\"bgo-cpn-clppd-offr\" class=\"bogo-coupon__details-info\">{{bogoTextDetail}}</div>\n                                    <span aria-live=\"polite\" class=\"sr-only\">{{adaText}}</span>\n                                </div>\n                            </div>\n                        </ng-container>\n\n                        <ng-container *ngIf=\"isOfferCompleteVisible(product)\">\n                            <div class=\"bogo-coupon bogo-coupon--offer-completed\">\n                                <div class=\"bogo-coupon__tick-icon\" data-qa=\"w-crt-itm-bg-cpn-clppd-icon\">\n                                    <span aria-hidden=\"true\" class=\"svg-checkedSucces\"></span>\n                                </div>\n                                <div class=\"bogo-coupon__details\" data-qa=\"bg-cpn-clppd-dtls\">\n                                    <div class=\"bogo-coupon__details-text\"> {{bogoText}} <span *ngIf=\"showDetailsLink && configObj?.programType !== '1P_SNS'\" data-qa=\"rw-crt-itm-bg-cpn-dtils-lnk\"\n                                                                                               (click)=\"setProductDetails('bogo-detail')\" (keyup.enter)=\"setProductDetails('bogo-detail')\"\n                                                                                               class=\"bogo-coupon__details-text__link\" role=\"button\" tabindex=\"0\"\n                                                                                               attr.aria-label=\"{{'Details for ' + bogoText + ' offer for ' + getProductFullName()}}\">Details</span>\n                                    </div>\n                                    <div class=\"bogo-coupon__details-info\" data-qa=\"bg-cpn-clppd-offr-cmpltd\">\n                                        <span aria-hidden=\"true\" data-qa=\"bg-cpn-clppd-offr-cmpltd-prty-icon\" class=\"bogo-coupon__details-info__party-icon\">\uD83C\uDF89</span>\n                                        <span class=\"sr-only\">Congratulations</span>\n                                        <span class=\"bogo-coupon__details-info__text\">Offer Complete!</span>\n                                    </div>\n                                </div>\n                            </div>\n                        </ng-container>\n                    </ng-container>\n                </ng-container>\n            </ng-container>\n        </div>\n    </div>\n</div>\n\n<div *ngIf=\"!coupons\" class=\"sm-empty-height\"></div>\n\n\n\n" }]
    }, {
        type: Injectable
    }], () => [{ type: i1.CommonService }, { type: i1.UserInfoService }, { type: i0.ElementRef }, { type: i1.CartService }, { type: i1.UtilService }, { type: i1.ProductCouponService }, { type: i1.CartV2Service }], { product: [{
            type: Input
        }], parentComponent: [{
            type: Input
        }], productOffers: [{
            type: Input
        }], couponCalledBy: [{
            type: Input
        }], showDetailsLink: [{
            type: Input
        }], showOfferComplete: [{
            type: Input
        }], isClickableMultipleCoupons: [{
            type: Input
        }], configObj: [{
            type: Input
        }], includeOffer: [{
            type: Input
        }], productCouponDetails: [{
            type: Output
        }], singleCouponClip: [{
            type: Output
        }], carouselTitle: [{
            type: Input,
            args: ['carouselTitle']
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ProductCouponALV1Component, { className: "ProductCouponALV1Component", filePath: "product-coupon-al-v1/product-coupon-al-v1.component.ts", lineNumber: 22 }); })();

function ProductCouponALV2Component_ng_container_0_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "button", 2);
    i0.ɵɵlistener("click", function ProductCouponALV2Component_ng_container_0_ng_container_1_ng_container_1_ng_container_1_Template_button_click_2_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(4); $event.stopPropagation(); return i0.ɵɵresetView(ctx_r1.setProductDetails("offer-detail")); })("keyup.enter", function ProductCouponALV2Component_ng_container_0_ng_container_1_ng_container_1_ng_container_1_Template_button_keyup_enter_2_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.setProductDetails("offer-detail")); });
    i0.ɵɵelementStart(3, "span", 3);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "button", 4);
    i0.ɵɵlistener("click", function ProductCouponALV2Component_ng_container_0_ng_container_1_ng_container_1_ng_container_1_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.clipCoupon()); });
    i0.ɵɵelement(6, "span", 5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", "Details for " + ctx_r1.singleCouponText + " coupon for " + ctx_r1.getProductFullName());
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.singleCouponText);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "couponAddBtn", ctx_r1.coupons[0].offerId, "");
    i0.ɵɵattribute("aria-label", "Clip coupon for " + ctx_r1.singleCouponText + " for " + ctx_r1.getProductFullName());
} }
function ProductCouponALV2Component_ng_container_0_ng_container_1_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "button", 6);
    i0.ɵɵlistener("click", function ProductCouponALV2Component_ng_container_0_ng_container_1_ng_container_1_ng_container_2_Template_button_click_2_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(4); $event.stopPropagation(); return i0.ɵɵresetView(ctx_r1.setProductDetails("offer-detail")); })("keyup.enter", function ProductCouponALV2Component_ng_container_0_ng_container_1_ng_container_1_ng_container_2_Template_button_keyup_enter_2_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.setProductDetails("offer-detail")); });
    i0.ɵɵelementStart(3, "span", 3);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(5, "span", 7);
    i0.ɵɵelementStart(6, "span", 8);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.singleCouponText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.adaText);
} }
function ProductCouponALV2Component_ng_container_0_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductCouponALV2Component_ng_container_0_ng_container_1_ng_container_1_ng_container_1_Template, 7, 5, "ng-container", 0)(2, ProductCouponALV2Component_ng_container_0_ng_container_1_ng_container_1_ng_container_2_Template, 8, 2, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.coupons[0] == null ? null : ctx_r1.coupons[0].status) === "U" || (ctx_r1.coupons[0] == null ? null : ctx_r1.coupons[0].deleted) === true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.coupons[0] == null ? null : ctx_r1.coupons[0].status) === "C" && (ctx_r1.coupons[0] == null ? null : ctx_r1.coupons[0].deleted) === false);
} }
function ProductCouponALV2Component_ng_container_0_ng_container_1_ng_container_2_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function ProductCouponALV2Component_ng_container_0_ng_container_1_ng_container_2_button_2_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(4); $event.stopPropagation(); return i0.ɵɵresetView(ctx_r1.setProductDetails("offer-detail")); })("keyup.enter", function ProductCouponALV2Component_ng_container_0_ng_container_1_ng_container_2_button_2_Template_button_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.setProductDetails("offer-detail")); });
    i0.ɵɵelementStart(1, "span", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵattribute("aria-label", "Details for " + ctx_r1.singleCouponText + " coupon for " + ctx_r1.getProductFullName());
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.singleCouponText);
} }
function ProductCouponALV2Component_ng_container_0_ng_container_1_ng_container_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "span", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 14);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate("Details for " + ctx_r1.singleCouponText + " coupon for " + ctx_r1.getProductFullName());
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.singleCouponText);
} }
function ProductCouponALV2Component_ng_container_0_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵtemplate(2, ProductCouponALV2Component_ng_container_0_ng_container_1_ng_container_2_button_2_Template, 3, 2, "button", 9)(3, ProductCouponALV2Component_ng_container_0_ng_container_1_ng_container_2_div_3_Template, 5, 2, "div", 10);
    i0.ɵɵelement(4, "span", 11);
    i0.ɵɵelementStart(5, "span", 8);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r1.configObj == null ? null : ctx_r1.configObj.programType) !== "1P_SNS");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.configObj == null ? null : ctx_r1.configObj.programType) === "1P_SNS");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.adaText);
} }
function ProductCouponALV2Component_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductCouponALV2Component_ng_container_0_ng_container_1_ng_container_1_Template, 3, 2, "ng-container", 0)(2, ProductCouponALV2Component_ng_container_0_ng_container_1_ng_container_2_Template, 7, 3, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.coupons[0] == null ? null : ctx_r1.coupons[0].isClippable) && (ctx_r1.coupons[0] == null ? null : ctx_r1.coupons[0].ecomDescription));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.coupons && ctx_r1.coupons.length > 0 && !ctx_r1.coupons[0].isClippable && ctx_r1.coupons[0].ecomDescription);
} }
function ProductCouponALV2Component_ng_container_0_ng_container_2_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function ProductCouponALV2Component_ng_container_0_ng_container_2_button_2_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(3); $event.stopPropagation(); return i0.ɵɵresetView(ctx_r1.setProductDetails("bogo-detail")); })("keyup.enter", function ProductCouponALV2Component_ng_container_0_ng_container_2_button_2_Template_button_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.setProductDetails("bogo-detail")); });
    i0.ɵɵelementStart(1, "span", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-label", "Details for " + ctx_r1.bogoText + " offer for " + ctx_r1.getProductFullName());
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.bogoText);
} }
function ProductCouponALV2Component_ng_container_0_ng_container_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "span", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 14);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate("Details for " + ctx_r1.bogoText + " offer for " + ctx_r1.getProductFullName());
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.bogoText);
} }
function ProductCouponALV2Component_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵtemplate(2, ProductCouponALV2Component_ng_container_0_ng_container_2_button_2_Template, 3, 2, "button", 9)(3, ProductCouponALV2Component_ng_container_0_ng_container_2_div_3_Template, 5, 2, "div", 10);
    i0.ɵɵelement(4, "span", 11);
    i0.ɵɵelementStart(5, "span", 8);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r1.configObj == null ? null : ctx_r1.configObj.programType) !== "1P_SNS");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.configObj == null ? null : ctx_r1.configObj.programType) === "1P_SNS");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.adaText);
} }
function ProductCouponALV2Component_ng_container_0_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "button", 17);
    i0.ɵɵlistener("click", function ProductCouponALV2Component_ng_container_0_ng_container_3_div_1_Template_button_click_1_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(3); $event.stopPropagation(); return i0.ɵɵresetView(ctx_r1.setProductDetails("coupon-list")); });
    i0.ɵɵelementStart(2, "span", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", ctx_r1.couponsText + " for " + ctx_r1.getProductFullName());
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.couponsText);
} }
function ProductCouponALV2Component_ng_container_0_ng_container_3_ng_container_2_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span", 11);
    i0.ɵɵelementStart(2, "span", 8);
    i0.ɵɵtext(3, "clipped");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function ProductCouponALV2Component_ng_container_0_ng_container_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 16)(2, "button", 17);
    i0.ɵɵlistener("click", function ProductCouponALV2Component_ng_container_0_ng_container_3_ng_container_2_Template_button_click_2_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(3); $event.stopPropagation(); return i0.ɵɵresetView(ctx_r1.setProductDetails("coupon-list")); });
    i0.ɵɵelementStart(3, "span", 3);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, ProductCouponALV2Component_ng_container_0_ng_container_3_ng_container_2_ng_container_5_Template, 4, 0, "ng-container", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", ctx_r1.couponsText + " for " + ctx_r1.getProductFullName() + " " + ctx_r1.offersClippedCounter + " of " + ctx_r1.availableOffersCounter + " clipped, view deals");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.multipleClippedCouponsText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.offersClippedCounter === ctx_r1.availableOffersCounter);
} }
function ProductCouponALV2Component_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductCouponALV2Component_ng_container_0_ng_container_3_div_1_Template, 4, 2, "div", 15)(2, ProductCouponALV2Component_ng_container_0_ng_container_3_ng_container_2_Template, 6, 3, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.offersClippedCounter === 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.offersClippedCounter > 0);
} }
function ProductCouponALV2Component_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductCouponALV2Component_ng_container_0_ng_container_1_Template, 3, 2, "ng-container", 0)(2, ProductCouponALV2Component_ng_container_0_ng_container_2_Template, 7, 3, "ng-container", 0)(3, ProductCouponALV2Component_ng_container_0_ng_container_3_Template, 3, 2, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isSingleOffer());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isSingleBogoOffer());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.availableOffersCounter > 1);
} }
class ProductCouponALV2Component {
    set carouselTitle(carouselTitle) {
        this._carouselTitle = carouselTitle;
    }
    get carouselTitle() {
        return this._carouselTitle;
    }
    constructor(_commonService, _userInfoService, _elementRef, cartService, _utilService, _productCouponService, cartV2Service) {
        this._commonService = _commonService;
        this._userInfoService = _userInfoService;
        this._elementRef = _elementRef;
        this.cartService = cartService;
        this._utilService = _utilService;
        this._productCouponService = _productCouponService;
        this.cartV2Service = cartV2Service;
        this.includeOffer = false;
        this.productCouponDetails = new EventEmitter();
        this.coupons = [];
        this.availableOffersCounter = 0;
        this.offersClippedCounter = 0;
        this.isBOGO = false;
        // Boxtop modal variables
        this.modalAttrName = 'modal';
        this.modalIdName = '#boxtop-modal';
        this.adaText = '';
        this.isWYSIWYGEnabled = false;
        // CMS BOGO texts
        this.bogoText = '';
        // Multiple coupons texts
        this.multipleClippedCouponsText = '';
        this.couponsText = '<counter> deals available';
    }
    ngOnInit() {
        this.productCouponInit();
    }
    productCouponInit() {
        this.isBOGO = this.isBogoOffer();
        // get coupons from offers if is product carousel item in
        if (this.productOffers && typeof this.productOffers['offers'] !== 'undefined' && this.productOffers['offers'] != null) {
            for (const offer in this.productOffers.offers) {
                if (this.productOffers.offers.hasOwnProperty(offer) && !this.couponIsExpired(offer)) {
                    this.coupons.push(this.productOffers.offers[offer]);
                }
            }
        }
        // get coupons from localStorage if empty
        if (this.coupons.length === 0 && !this.includeOffer) {
            this.processFromLocalStorage();
        }
        this.productDetails = {
            'product': this.product,
            'offerCounter': this.availableOffersCounter,
            'offerClipped': this.offersClippedCounter,
            'coupons': this.coupons
        };
        this.productCouponDetails.emit(this.productDetails);
        this.processOfferByType();
        this._commonService.shopCouponRefresh.subscribe(isRefresh => {
            if (isRefresh) {
                this.processFromLocalStorage();
                const tempCoupons = JSON.parse(JSON.stringify(this.coupons));
                if (tempCoupons.length > 0) {
                    this.coupons = this.cartService.processOfferComplete(this.cartDetails, tempCoupons, this.product);
                }
                this.cartService.processBOGOComplete(this.cartDetails, this.product);
                this.processOfferByType();
                this.productDetails = {
                    'product': this.product,
                    'offerCounter': this.availableOffersCounter,
                    'offerClipped': this.offersClippedCounter,
                    'coupons': this.coupons
                };
                this.productCouponDetails.emit(this.productDetails);
            }
        });
        // check and update statuses when cart is updated
        this._commonService.currentCartObj.subscribe(objCart => {
            const singleCart = this.cartV2Service.fetchCartDetailsFromResponse(objCart, this.cartV2Service.getCartName(this.configObj.programType));
            this.cartDetails = singleCart;
            this.isWYSIWYGEnabled = this.cartDetails['isWYSIWYGEnabled'];
            const tempCoupons = JSON.parse(JSON.stringify(this.coupons));
            if (tempCoupons.length > 0) {
                this.coupons = this.cartService.processOfferComplete(this.cartDetails, tempCoupons, this.product);
            }
            this.cartService.processBOGOComplete(this.cartDetails, this.product);
        });
        /**
            * Subscribe to clipCouponSource event based on product upc to trriger clipCoupon method
            * Only for selected product not for all products instance
            * Check if the coupon is digital , unclipped and single coupon
        */
        this._clipCouponSubscription = this._productCouponService.clipDigitalCouponEvent$.pipe(filter(productUpc => (productUpc === this.product.upc) && this._isSingleUnClipDigitalCoupon())).subscribe(productUpc => {
            this.clipCoupon();
        });
    }
    processOfferByType() {
        this.coupons = this.coupons.filter(coupon => coupon.isClippable || (!coupon.isClippable && coupon.ecomDescription));
        this.availableOffersCounter = (this.coupons) ? this.coupons.length : 0;
        // check number of offers clipped
        this.offersClippedCounter = (this.availableOffersCounter > 0) ? this._productCouponService.getOffersClipped(this.coupons) : 0;
        if (this.isBOGO) {
            this.availableOffersCounter = this.availableOffersCounter + 1;
            this.offersClippedCounter = this.offersClippedCounter + 1;
            this.setBogoText();
        }
        // set text for single coupon
        this.setSingleCouponText();
        // set text for clipped coupon
        this.setClippedCouponsText();
        // set text when all coupons are unclipped
        if (this.availableOffersCounter > 1) {
            this.couponsText = this.couponsText.replace('<counter>', this.availableOffersCounter.toString());
        }
    }
    // set text for bogo cms
    setBogoText() {
        this.bogoText = this.product.promoDescription ? `${this.product.promoDescription}` : '';
    }
    setSingleCouponText() {
        if (this.availableOffersCounter === 1 && this.coupons.length === 1) {
            this.singleCouponText = this.coupons[0].ecomDescription;
            this.coupons[0].offerComplete = this.coupons[0].offerComplete ? this.coupons[0].offerComplete : false;
        }
    }
    /**
     * Set the text for clipped coupons
     */
    setClippedCouponsText() {
        this.multipleClippedCouponsText = `${this.offersClippedCounter} of ${this.availableOffersCounter} clipped`;
    }
    /**
     * @return true or false if the product is a BOGO offer
     */
    isBogoOffer() {
        return (this.product.promoType === 'M' || this.product.promoType === 'B');
    }
    /**
     * Get the coupons based on parent component
     */
    processFromLocalStorage() {
        let couponsResult = [];
        if (localStorage.getItem('abCoupons')) {
            couponsResult = this._commonService.getCouponByUpc(this.product.upc);
        }
        else {
            const offers = [];
            if (this._commonService.objPageCoupons
                && this._commonService.objPageCoupons['offersByUpc']
                && this._commonService.objPageCoupons['offersByUpc'][this.product.upc]
                && this._commonService.objPageCoupons['offers']) {
                this._commonService.objPageCoupons['offersByUpc'][this.product.upc].forEach(offer => {
                    offers.push(this._commonService.objPageCoupons['offers'][offer]);
                });
            }
            couponsResult = offers;
        }
        this.coupons = couponsResult;
    }
    couponIsExpired(coupon) {
        return this._productCouponService.isCouponExpired(coupon);
    }
    productPromoIsActive(product) {
        return this._commonService.isProductPromoActive(product);
    }
    /**
     * Clip coupon when only one is available
     */
    clipCoupon() {
        if (this.coupons[0]['offerSubPgm'] === '07' && (window['AB'].userInfo.boxTopAuth || !this._isRegistered())) {
            this.modalAttrName = '';
            this.modalIdName = '';
        }
        if (this._isRegistered()) {
            const storeId = window['AB']['userInfo']['branchId'];
            this._updateAnalyticsDataLayer();
            this._updateAnalyticsCarouselName();
            this._productCouponService.clipCoupon(this.coupons[0], storeId).subscribe(response => {
                if (response && response['items'] && response['items'][0] && response['items'][0]['status'] === 1) {
                    this.offersClippedCounter = 1;
                    setTimeout(() => {
                        $('#clippedCoupon' + this.coupons[0].offerId).focus();
                        this.adaText = `${this.coupons[0].ecomDescription} coupon has been clipped.`;
                    }, 100);
                    setTimeout(() => {
                        this.adaText = '';
                    }, 500);
                }
            });
        }
        else {
            window['AB']['COMMON'].showSignInModal_OTP(window.location.href);
        }
    }
    /**
     *  Checking whether the coupon is digital and single coupon or not
    */
    _isSingleUnClipDigitalCoupon() {
        if (this.availableOffersCounter === 1 && !this.isBOGO) {
            return this.coupons[0]?.isClippable && (this.coupons[0]?.status === 'U' || this.coupons[0]?.deleted === true);
        }
        return false;
    }
    /**
     * Analytics method for updating productInfo
     */
    _updateAnalyticsDataLayer() {
        if (window['AB'] && window['AB']['DATALAYER']) {
            const analyticsCarouselTitle = this._carouselTitle ||
                window['AB']['DATALAYER'].getAnalyticsCarouselTitle(this._elementRef.nativeElement);
            window['AB']['DATALAYER'].productInfo({
                id: this.product.id,
                name: this.product.name,
                units: this.product.units,
                listPrice: this.product.price,
                basePrice: this.product.basePrice,
                carouselSection: analyticsCarouselTitle || '',
                pricingType: this.product.promoDescriptionVal || '',
                couponID: this.coupons.filter(offer => offer.status === 'C').map(offer => offer.offerId).toString(),
                couponFlag: this.availableOffersCounter,
                couponClipped: this.offersClippedCounter,
                aisleId: this.product.aisleId,
                upc: this.product.upc
            });
        }
    }
    /**
     * Analytics method for sending the offer info with the linkClick event
     * param offerType
     * param offerName
     */
    _updateAnalyticsLinkClick(offerType, offerName) {
        if (window['AB'] && window['AB']['DATALAYER']) {
            if (offerName) {
                window['AB']['DATALAYER'].setLinkClickOfferDrawer(offerType, offerName, this._elementRef.nativeElement);
            }
            else {
                let multipleText = '';
                if (this.offersClippedCounter === 0) {
                    multipleText = `${this.availableOffersCounter} Coupons Available`;
                    window['AB']['DATALAYER'].setLinkClickOfferDrawer(offerType, multipleText, this._elementRef.nativeElement);
                }
                else if (this.offersClippedCounter > 0) {
                    multipleText = `${this.offersClippedCounter} of ${this.availableOffersCounter} Coupons Clipped`;
                    window['AB']['DATALAYER'].setLinkClickOfferDrawer(offerType, multipleText, this._elementRef.nativeElement);
                }
            }
        }
    }
    _updateAnalyticsModalViewSNS(name) {
        if (window['AB'] && window['AB']['DATALAYER']) {
            window['AB']['DATALAYER'].setModalViewEvents(name);
        }
    }
    /**
     * Analytics method for updating the carousel name
     */
    _updateAnalyticsCarouselName() {
        if (window['AB']['DATALAYER'] && this._carouselTitle) {
            window['AB']['DATALAYER'].setCarouselName('shop|' + this._carouselTitle);
        }
    }
    setProductDetails(drawerType, coupon) {
        //Check if snsOneTime programType is set and emit event else do default behavior
        if (this.configObj.programType === '1P_SNS') {
            switch (drawerType) {
                case 'offer-detail':
                    this._commonService.dispatchSnsOneTimeEvent('singleCoupon', { coupons: this.coupons[0] });
                    this._updateAnalyticsModalViewSNS('offer-details-j4u-productcards|view');
                    break;
                case 'coupon-list':
                    this._commonService.dispatchSnsOneTimeEvent('multipleCoupons', { product: this.product });
                    this._updateAnalyticsModalViewSNS('offer-details-multiple-productcards|view');
                    break;
            }
        }
        else {
            let objDrawerData = {};
            // reset name property to default value to properly display the tooltip.
            if (drawerType === 'coupon-list') {
                objDrawerData = {
                    type: drawerType,
                    couponList: this.coupons,
                    product: this.product
                };
                this._updateAnalyticsLinkClick('offer-drawer-multiple-productcards', null);
            }
            else if (drawerType === 'offer-detail') {
                objDrawerData = {
                    type: drawerType,
                    coupon: this.coupons[0],
                    product: this.product,
                    triggeredElement: 'single-coupon-product-card'
                };
                this._updateAnalyticsLinkClick('offer-drawer-j4u-productcards', this.singleCouponText);
            }
            else if (drawerType === 'bogo-detail') {
                objDrawerData = {
                    type: drawerType,
                    product: this.product,
                    triggeredElement: 'single-coupon-product-card'
                };
                this._updateAnalyticsLinkClick('offer-drawer-bogo-productcards', this.bogoText);
            }
            objDrawerData = { ...objDrawerData, configObj: this.configObj };
            this._commonService.rightDrawerSource.next(objDrawerData);
        }
    }
    getProductFullName() {
        let fullName = '';
        if (this.product) {
            fullName = this.product.fullName ? this.product.fullName : this.product.name;
        }
        return fullName;
    }
    /**
     * Method for checking if there is a single offer and is a BOGO
     * @return true or false if token is active and use is authorized
     */
    _isRegistered() {
        return (this._utilService.isTokenActive() && this._userInfoService.isAuthorized());
    }
    /**
     * Method for checking if there is a single offer and is a coupon
     *
     * @return true or false based on the number of available offers
     */
    isSingleOffer() {
        return (this.availableOffersCounter === 1 && !this.isBOGO);
    }
    /**
     * Method for checking if there is a single offer and is a BOGO
     *
     * @return true or false if the number of available offers is 1 and is a BOGO
     */
    isSingleBogoOffer() {
        return this.availableOffersCounter === 1 && this.isBOGO && this.productPromoIsActive(this.product);
    }
    ngOnDestroy() {
        this._clipCouponSubscription?.unsubscribe();
    }
    static { this.ɵfac = function ProductCouponALV2Component_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ProductCouponALV2Component)(i0.ɵɵdirectiveInject(i1.CommonService), i0.ɵɵdirectiveInject(i1.UserInfoService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.CartService), i0.ɵɵdirectiveInject(i1.UtilService), i0.ɵɵdirectiveInject(i1.ProductCouponService), i0.ɵɵdirectiveInject(i1.CartV2Service)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProductCouponALV2Component, selectors: [["product-coupon-al-v2"]], inputs: { product: "product", productOffers: "productOffers", couponCalledBy: "couponCalledBy", configObj: "configObj", includeOffer: "includeOffer", carouselTitle: "carouselTitle" }, outputs: { productCouponDetails: "productCouponDetails" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "product-coupon__info", "d-flex", "sunshine50", "px-2", "py-1"], [1, "border-0", "sunshine50", "p-0", 3, "click", "keyup.enter"], [1, "body-text-xs", "product-coupon__info__text", "text-wrap", "text-left", "color-neutral-90"], ["data-qa", "clpscssrs-btn", 1, "product-coupon__icon-circle", "rounded-circle", "p-0", "d-flex", "justify-content-center", "align-items-center", 3, "click", "id"], [1, "svg-scissor", "background-color-primary-default", "m-0"], ["attr.aria-label", "{{'singleCouponText + ' coupon clipped for ' + getProductFullName()}}", 1, "border-0", "sunshine50", "p-0", 3, "click", "keyup.enter"], ["data-qa", "clpchk-btn", "aria-hidden", "true", 1, "svg-coupon-redesign-tick-mark", "background-color-primary-default", "m-1"], ["aria-live", "polite", 1, "sr-only"], ["class", "border-0 sunshine50 p-0", 3, "click", "keyup.enter", 4, "ngIf"], ["class", "border-0 sunshine50 p-0", 4, "ngIf"], ["aria-hidden", "true", 1, "svg-coupon-redesign-tick-mark", "background-color-primary-default", "m-1"], [1, "border-0", "sunshine50", "p-0"], [1, "sr-only"], ["aria-hidden", "true", 1, "body-text-xs", "product-coupon__info__text", "text-wrap", "text-left", "color-neutral-90"], ["aria-live", "polite", "class", "product-coupon__info d-flex sunshine50 px-2 py-1", 4, "ngIf"], ["aria-live", "polite", 1, "product-coupon__info", "d-flex", "sunshine50", "px-2", "py-1"], ["data-qa", "prd-itm-multi-coupon", 1, "border-0", "sunshine50", "p-0", 3, "click"]], template: function ProductCouponALV2Component_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ProductCouponALV2Component_ng_container_0_Template, 4, 3, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.availableOffersCounter > 0);
        } }, dependencies: [i2.NgIf], encapsulation: 2 }); }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProductCouponALV2Component, factory: ProductCouponALV2Component.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductCouponALV2Component, [{
        type: Component,
        args: [{ selector: 'product-coupon-al-v2', template: "<ng-container *ngIf=\"availableOffersCounter > 0\">\n    <!-- Product item offers -->\n        <!-- Single offer -->\n    <ng-container *ngIf=\"isSingleOffer()\">\n        <ng-container *ngIf=\"coupons[0]?.isClippable && coupons[0]?.ecomDescription\">\n            <ng-container *ngIf=\"coupons[0]?.status === 'U' || coupons[0]?.deleted === true\">\n                <div class=\"product-coupon__info d-flex sunshine50 px-2 py-1\">\n                    <button class=\"border-0 sunshine50 p-0\" (click)=\"$event.stopPropagation();setProductDetails('offer-detail');\"\n                    (keyup.enter)=\"setProductDetails('offer-detail')\" attr.aria-label=\"{{'Details for ' + singleCouponText + ' coupon for ' + getProductFullName()}}\">\n                        <span\n                            class=\"body-text-xs product-coupon__info__text text-wrap text-left color-neutral-90\">{{singleCouponText}}</span>\n                    </button>\n                    <button data-qa=\"clpscssrs-btn\" class=\"product-coupon__icon-circle rounded-circle p-0 d-flex justify-content-center align-items-center\" (click)=\"clipCoupon()\" id=\"couponAddBtn{{coupons[0].offerId}}\"\n                        attr.aria-label=\"{{'Clip coupon for ' + singleCouponText + ' for ' + getProductFullName()}}\">\n                        <span class=\"svg-scissor background-color-primary-default m-0\"></span>\n                    </button>\n                </div>\n            </ng-container>\n            <ng-container *ngIf=\"coupons[0]?.status === 'C' && coupons[0]?.deleted === false\">\n                    <div class=\"product-coupon__info d-flex sunshine50 px-2 py-1\">\n                        <button class=\"border-0 sunshine50 p-0\" (click)=\"$event.stopPropagation();setProductDetails('offer-detail');\"\n                        (keyup.enter)=\"setProductDetails('offer-detail')\"  attr.aria-label=\"{{'singleCouponText + ' coupon clipped for ' + getProductFullName()}}\">\n                            <span\n                                class=\"body-text-xs product-coupon__info__text text-wrap text-left color-neutral-90\">{{singleCouponText}}</span>\n                        </button>\n                        <span data-qa=\"clpchk-btn\" class=\"svg-coupon-redesign-tick-mark background-color-primary-default m-1\"\n                            aria-hidden=\"true\"></span>\n                        <span aria-live=\"polite\" class=\"sr-only\">{{adaText}}</span>\n                    </div>\n            </ng-container>\n        </ng-container>\n        <!-- To display NDC coupons -->\n        <ng-container *ngIf=\"coupons && coupons.length > 0 && !coupons[0].isClippable && coupons[0].ecomDescription\">\n            <div class=\"product-coupon__info d-flex sunshine50 px-2 py-1\">\n                <button *ngIf=\"configObj?.programType !== '1P_SNS'\" class=\"border-0 sunshine50 p-0\"  (click)=\"$event.stopPropagation();setProductDetails('offer-detail');\"\n                (keyup.enter)=\"setProductDetails('offer-detail')\"  attr.aria-label=\"{{'Details for ' + singleCouponText + ' coupon for ' + getProductFullName()}}\">\n                    <span\n                        class=\"body-text-xs product-coupon__info__text text-wrap text-left color-neutral-90\">{{singleCouponText}}</span>\n                </button>\n                <div *ngIf=\"configObj?.programType === '1P_SNS'\" class=\"border-0 sunshine50 p-0\">\n                    <span class=\"sr-only\">{{'Details for ' + singleCouponText + ' coupon for ' + getProductFullName()}}</span>\n                    <span aria-hidden=\"true\" class=\"body-text-xs product-coupon__info__text text-wrap text-left color-neutral-90\">{{singleCouponText}}</span>\n                </div>\n                <span class=\"svg-coupon-redesign-tick-mark background-color-primary-default m-1\"\n                    aria-hidden=\"true\"></span>\n                <span aria-live=\"polite\" class=\"sr-only\">{{adaText}}</span>\n            </div>\n        </ng-container>\n    </ng-container>\n\n    <!-- if promotype is equal to M or B -->\n    <ng-container *ngIf=\"isSingleBogoOffer()\">\n        <div class=\"product-coupon__info d-flex sunshine50 px-2 py-1\">\n            <button *ngIf=\"configObj?.programType !== '1P_SNS'\" class=\"border-0 sunshine50 p-0\"\n                (click)=\"$event.stopPropagation();setProductDetails('bogo-detail');\" (keyup.enter)=\"setProductDetails('bogo-detail')\"\n                attr.aria-label=\"{{'Details for ' + bogoText + ' offer for ' + getProductFullName()}}\">\n                <span\n                    class=\"body-text-xs product-coupon__info__text text-wrap text-left color-neutral-90\">{{bogoText}}</span>\n            </button>\n    \n            <div *ngIf=\"configObj?.programType === '1P_SNS'\" class=\"border-0 sunshine50 p-0\">\n                <span class=\"sr-only\">{{'Details for ' + bogoText + ' offer for ' + getProductFullName()}}</span>\n                <span aria-hidden=\"true\" class=\"body-text-xs product-coupon__info__text text-wrap text-left color-neutral-90\">{{bogoText}}</span>\n            </div>\n            <span class=\"svg-coupon-redesign-tick-mark background-color-primary-default m-1\" aria-hidden=\"true\"></span>\n            <span aria-live=\"polite\" class=\"sr-only\">{{adaText}}</span>\n        </div>\n    </ng-container>\n\n    <!-- Multiple offers -->\n    <ng-container *ngIf=\"availableOffersCounter > 1\">\n        <div aria-live=\"polite\" class=\"product-coupon__info d-flex sunshine50 px-2 py-1\" *ngIf=\"offersClippedCounter === 0\" >\n            <button (click)=\"$event.stopPropagation();setProductDetails('coupon-list');\" attr.aria-label=\"{{ couponsText + ' for ' + getProductFullName()}}\"\n            class=\"border-0 sunshine50 p-0\" data-qa=\"prd-itm-multi-coupon\">\n                <span class=\"body-text-xs product-coupon__info__text text-wrap text-left color-neutral-90\">{{couponsText}}</span>\n            </button>\n        </div>\n        <ng-container *ngIf=\"offersClippedCounter > 0\">\n            <div aria-live=\"polite\" class=\"product-coupon__info d-flex sunshine50 px-2 py-1\"  >\n                <button (click)=\"$event.stopPropagation();setProductDetails('coupon-list');\" class=\"border-0 sunshine50 p-0\" data-qa=\"prd-itm-multi-coupon\" \n                attr.aria-label=\"{{ couponsText + ' for ' + getProductFullName() + ' ' + offersClippedCounter + ' of ' + availableOffersCounter +' clipped, view deals' }}\">\n                    <span class=\"body-text-xs product-coupon__info__text text-wrap text-left color-neutral-90\">{{multipleClippedCouponsText}}</span>\n                </button>\n                <ng-container *ngIf=\"offersClippedCounter === availableOffersCounter\" >\n                    <span class=\"svg-coupon-redesign-tick-mark background-color-primary-default m-1\" aria-hidden=\"true\"></span>\n                    <span aria-live=\"polite\" class=\"sr-only\">clipped</span>\n                </ng-container>\n            </div>\n        </ng-container>\n    </ng-container>\n</ng-container>\n\n\n\n" }]
    }, {
        type: Injectable
    }], () => [{ type: i1.CommonService }, { type: i1.UserInfoService }, { type: i0.ElementRef }, { type: i1.CartService }, { type: i1.UtilService }, { type: i1.ProductCouponService }, { type: i1.CartV2Service }], { product: [{
            type: Input
        }], productOffers: [{
            type: Input
        }], couponCalledBy: [{
            type: Input
        }], configObj: [{
            type: Input
        }], includeOffer: [{
            type: Input
        }], productCouponDetails: [{
            type: Output
        }], carouselTitle: [{
            type: Input,
            args: ['carouselTitle']
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ProductCouponALV2Component, { className: "ProductCouponALV2Component", filePath: "product-coupon-al-v2/product-coupon-al-v2.component.ts", lineNumber: 19 }); })();

class ProductCouponModule {
    static { this.ɵfac = function ProductCouponModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ProductCouponModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ProductCouponModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            ProductCouponALV1Component,
        ], imports: [CommonModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductCouponModule, [{
        type: NgModule,
        args: [{
                declarations: [ProductCouponALV1Component, ProductCouponALV2Component],
                exports: [
                    ProductCouponALV1Component,
                    ProductCouponALV2Component
                ],
                imports: [
                    CommonModule
                ],
                providers: [
                    ProductCouponALV1Component,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ProductCouponModule, { declarations: [ProductCouponALV1Component, ProductCouponALV2Component], imports: [CommonModule], exports: [ProductCouponALV1Component,
        ProductCouponALV2Component] }); })();

// //Component

/**
 * Generated bundle index. Do not edit.
 */

export { ProductCouponALV1Component, ProductCouponALV2Component, ProductCouponModule };
